<template>
	<div class="o-dashboard">

		<div class="flex flex-align-center flex-space-between margin-t-32 margin-b-8 margin-h-16">
			<h3 class="margin-b-16 show-for-large">Dashboard</h3>
			<div class="flex">
				<div class="margin-r-16">
					<c-select
						:options="yearOptions"
						v-model="filterYear"
						name="filter_year"
						:ValueName="'id'"
						DisplayName="name"
						whiteBg>
					</c-select>
				</div>
				<div>
					<c-select
						:options="customers"
						v-model="filterCompany"
						name="filter_company"
						:ValueName="'id'"
						DisplayName="name"
						whiteBg>
					</c-select>
					<span v-if="error" class="c-form__error-message" data-validation-error="">Dit veld is verplicht.</span>
				</div>
			</div>
		</div>

		<Loader :loading="loading">
		<div class="row">
			<div class="column small-12 xlarge-4 margin-b-24">
				<div class="c-panel c-panel--no-shadow c-panel--medium-padding">
					<div class="flex flex-space-between">
						<div>
							<div class="color-gray-600">In gebruik</div>
							<h3 class="no-margin">{{ total_items_in_use }}</h3>
						</div>
						<div class="flex flex-align-center">
							<svg v-if="filterCompany" @click="exportInUse" class="color-primary margin-r-24 cursor-pointer" xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><path fill="currentColor" d="M369 217L241 345c-9.4 9.4-24.6 9.4-33.9 0L79 217c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87V24c0-13.3 10.7-24 24-24s24 10.7 24 24V270.1l87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM48 344v80c0 22.1 17.9 40 40 40H360c22.1 0 40-17.9 40-40V344c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 48.6-39.4 88-88 88H88c-48.6 0-88-39.4-88-88V344c0-13.3 10.7-24 24-24s24 10.7 24 24z"/></svg>
							<svg v-if="total_items_in_use > 0" @click="openAccordion('inUse')" class="color-secondary cursor-pointer" :class="{'rotate-180' : openPanels.inUse}" xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><path fill="currentColor" d="M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM135 241c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 345c-9.4 9.4-24.6 9.4-33.9 0L135 241z"/></svg>
						</div>
					</div>
					<div class="padding-t-16" v-if="openPanels.inUse">
						<div class="flex flex-space-between padding-v-6 border-bottom-gray-200 fs-xsmall" v-for="total, category  in usedCategories">
							<div class="color-gray-600">{{ category }}</div>
							<div class="color-gray-800">{{total}}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="column small-12 xlarge-4 margin-b-24">
				<div class="c-panel c-panel--no-shadow c-panel--medium-padding">
					<div class="flex flex-space-between">
						<div>
							<div class="color-gray-600">Op voorraad</div>
							<h3 class="no-margin">{{total_items_in_stock}}</h3>
						</div>
						<div class="flex flex-align-center">
							<svg v-if="filterCompany" @click="exportInStock" class="color-primary margin-r-24 cursor-pointer" xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><path fill="currentColor" d="M369 217L241 345c-9.4 9.4-24.6 9.4-33.9 0L79 217c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87V24c0-13.3 10.7-24 24-24s24 10.7 24 24V270.1l87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM48 344v80c0 22.1 17.9 40 40 40H360c22.1 0 40-17.9 40-40V344c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 48.6-39.4 88-88 88H88c-48.6 0-88-39.4-88-88V344c0-13.3 10.7-24 24-24s24 10.7 24 24z"/></svg>
							<svg v-if="total_items_in_stock > 0" @click="openAccordion('inStock')" class="color-secondary cursor-pointer" :class="{'rotate-180' : openPanels.inStock}" xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><path fill="currentColor" d="M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM135 241c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 345c-9.4 9.4-24.6 9.4-33.9 0L135 241z"/></svg>
						</div>
					</div>
					<div class="padding-t-16" v-if="openPanels.inStock">
						<div class="flex flex-space-between padding-v-6 border-bottom-gray-200 fs-xsmall" v-for="total, category  in inStockCategories">
							<div class="color-gray-600">{{category}}</div>
							<div class="color-gray-800">{{total}}</div>
						</div>

					</div>
				</div>
			</div>
			<div class="column small-12 xlarge-4 margin-b-24">
				<div class="c-panel c-panel--no-shadow c-panel--medium-padding">
					<div class="flex flex-space-between">
						<div>
							<div class="color-gray-600">In reparatie</div>
							<h3 class="no-margin">{{total_items_in_repair}}</h3>
						</div>
						<div class="flex flex-align-center">
							<svg v-if="filterCompany" @click="exportInRepair" class="color-primary margin-r-24 cursor-pointer" xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 448 512"><path fill="currentColor" d="M369 217L241 345c-9.4 9.4-24.6 9.4-33.9 0L79 217c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87V24c0-13.3 10.7-24 24-24s24 10.7 24 24V270.1l87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9zM48 344v80c0 22.1 17.9 40 40 40H360c22.1 0 40-17.9 40-40V344c0-13.3 10.7-24 24-24s24 10.7 24 24v80c0 48.6-39.4 88-88 88H88c-48.6 0-88-39.4-88-88V344c0-13.3 10.7-24 24-24s24 10.7 24 24z"/></svg>
							<svg v-if="total_items_in_repair > 0" @click="openAccordion('inRepair')" class="color-secondary cursor-pointer" :class="{'rotate-180' : openPanels.inRepair}" xmlns="http://www.w3.org/2000/svg" height="1em" viewBox="0 0 512 512"><path fill="currentColor" d="M256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM135 241c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l87 87 87-87c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9L273 345c-9.4 9.4-24.6 9.4-33.9 0L135 241z"/></svg>
						</div>
					</div>
					<div class="padding-t-16" v-if="openPanels.inRepair">
						<div class="flex flex-space-between padding-v-6 border-bottom-gray-200 fs-xsmall" v-for="total, category in inRepairCategories">
							<div class="color-gray-600">{{category}}</div>
							<div class="color-gray-800">{{total}}</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="column small-12 xlarge-8 margin-b-24">
				<div class="c-panel c-panel--h-full c-panel--no-shadow c-panel--medium-padding">
					<h6 class="margin-b-16">Asset Management</h6>
					<div class="chart-container relative" style="height:360px;width:100%">
						<Bar :data="assetManagementChart" :options="chartsOptions" />
					</div>
				</div>
			</div>
			<div class="column small-12 xlarge-4 margin-b-24">
				<div class="c-panel c-panel--h-full c-panel--no-shadow c-panel--medium-padding">
					<h6 class="margin-b-16">End of life</h6>
					<div class="div">
						<div v-for="item, month in endOfLife" class="flex flex-space-between padding-v-6 border-bottom-gray-200 fs-xsmall">
							<div class="color-gray-600">{{month}}</div>
							<div class="flex">
								<div class="fw-bold color-gray-800">{{item.amount}}</div>
								<div
									style="width:40px"
									class="margin-l-16 text-right"
									:class="[
										{'color-primary' : item.ratio != 0 && item.past}
									]">
									{{item.ratio}} %
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="column small-12 xlarge-6 margin-b-24">
				<div class="c-panel c-panel--h-full c-panel--no-shadow c-panel--medium-padding">
					<h6 class="margin-b-16">Indiensttredingen</h6>
					<div class="chart-container relative" style="height:320px;width:100%">
						<Bar :data="enlistments" :options="chartsOptions" />
					</div>
				</div>
			</div>
			<div class="column small-12 xlarge-6 margin-b-24">
				<div class="c-panel c-panel--h-full c-panel--no-shadow c-panel--medium-padding">
					<h6 class="margin-b-16">Uitdiensttredingen</h6>
					<div class="chart-container relative" style="height:320px;width:100%">
						<Bar :data="departures" :options="chartsOptions" />
					</div>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="column small-12 xlarge-6 margin-b-24">
				<div class="c-panel c-panel--h-full c-panel--no-shadow c-panel--medium-padding">
					<h6 class="margin-b-16">Bulkleveringen</h6>
					<div class="chart-container relative" style="height:320px;width:100%">
						<Bar :data="bulk" :options="chartsOptions" />
					</div>
				</div>
			</div>
			<div class="column small-12 xlarge-6 margin-b-24">
				<div class="c-panel c-panel--h-full c-panel--no-shadow c-panel--medium-padding">
					<h6 class="margin-b-16">Swap aanvragen</h6>
					<div class="chart-container relative" style="height:320px;width:100%">
						<Bar :data="swapRequests" :options="chartsOptions" />
					</div>
				</div>
			</div>
		</div>

		<div class="row">
			<div class="column small-12 xlarge-6 margin-b-24">
				<div class="c-panel c-panel--h-full c-panel--no-shadow c-panel--medium-padding">
					<h6 class="margin-b-16">Mutatie aanvragen</h6>
					<div class="chart-container relative" style="height:320px;width:100%">
						<Bar :data="mutationRequests" :options="chartsOptions" />
					</div>
				</div>
			</div>
			<div class="column small-12 xlarge-6 margin-b-24">
				<div class="c-panel c-panel--h-full c-panel--no-shadow c-panel--medium-padding">
					<h6 class="margin-b-16">Reparaties</h6>
					<div class="row">
						<div class="columns small-6">
							<div v-for="item in repairsPerMonth.slice(0, 6)" class="flex flex-space-between padding-v-6 border-bottom-gray-200 fs-xsmall">
								<div class="color-gray-600">{{item.month}}</div>
								<div class="color-gray-800 fw-bold">{{item.amount}}</div>
							</div>
						</div>
						<div class="columns small-6">
							<div v-for="item in repairsPerMonth.slice(6, 12)" class="flex flex-space-between padding-v-6 border-bottom-gray-200 fs-xsmall">
								<div class="color-gray-600">{{item.month}}</div>
								<div class="color-gray-800 fw-bold">{{item.amount}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</Loader>
	</div>
</template>

<script>
import View from '@mixins/View';
import Form from '@mixins/Form';
import Loader from '@components/loader/Container';

import {
	Chart as ChartJS,
	Title,
	Tooltip,
	Legend,
	BarElement,
	CategoryScale,
	LinearScale,
	LineElement,
	PointElement
} from 'chart.js'

import { Bar, Line } from 'vue-chartjs'
ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, Title, Tooltip, Legend)

export default {
	mixins: [ View, Form ],
	components: { Bar, Line, Loader },
	data() {
		return {
			error:false,
			customers: [],
			filterYear: new Date().getFullYear(),
			filterCompany: '',
			total_items_in_stock: 0,
			total_items_in_use: 0,
			total_items_in_repair: 0,
			usedCategories: [],
			inStockCategories: [],
			inRepairCategories: [],
			loading: false,
			colors: ['#8ABDE0', '#F9A98C', '#D6D6D6', '#FDD889', '#AFAFAF', '#F9A98C', '#D6D6D6', '#FDD889', '#AFAFAF'],
			chartsOptions: {
				responsive: true,
				maintainAspectRatio: false,
				plugins: {
					legend: {
						position: 'bottom',
						labels: {
							padding: 20,
						}
					}
				},
				scales: {
					y: {
						beginAtZero: true,
						grace: '5%'
					}
				}
			},
			openPanels: {
				inUse: false,
				inStock: false,
				inRepair: false,
			},
			assetManagementChart: {
				labels: [
					'Januari','Februari','Maart','April','Mei','Juni','Juli','Augustus','September','Oktober','November','December'
				],
				datasets: []
			},
			endOfLife:
			{ "januari": 0, "februari": 0, "maart": 0, "april": 0, "mei": 0, "juni": 0, "juli": 0, "augustus": 0, "september": 0, "oktober": 0, "november": 0, "december": 0 },
			enlistments: {
				labels: [
					'Januari','Februari','Maart','April','Mei','Juni','Juli','Augustus','September','Oktober','November','December'
				],
				datasets: [],
			},
			bulk: {
				labels: [
					'Januari','Februari','Maart','April','Mei','Juni','Juli','Augustus','September','Oktober','November','December'
				],
				datasets: [],
			},
			departures: {
				labels: [
					'Januari','Februari','Maart','April','Mei','Juni','Juli','Augustus','September','Oktober','November','December'
				],
				datasets: [],
			},
			swapRequests: {
				labels: [
					'Januari','Februari','Maart','April','Mei','Juni','Juli','Augustus','September','Oktober','November','December'
				],
				datasets: [],
			},
			mutationRequests: {
				labels: [
					'Januari','Februari','Maart','April','Mei','Juni','Juli','Augustus','September','Oktober','November','December'
				],
				datasets: [],
			},
			repairsPerMonth: [
				{ "month": "januari", "amount": 0 },
				{ "month": "februari", "amount": 0 },
				{ "month": "maart", "amount": 0 },
				{ "month": "april", "amount": 0 },
				{ "month": "mei", "amount": 0 },
				{ "month": "juni", "amount": 0 },
				{ "month": "juli", "amount": 0 },
				{ "month": "augustus", "amount": 0 },
				{ "month": "september", "amount": 0 },
				{ "month": "oktober", "amount": 0 },
				{ "month": "november", "amount": 0 },
				{ "month": "december", "amount": 0 }
			]
		}
	},
	watch: {
		filterCompany() {
			this.error = false;
			this.loading = true;
			this.error = false;
			this.loadData();
		},
		filterYear() {
			if(this.filterCompany){
				this.loading = true;
				this.loadData();
			}
			else{
				this.error = true;
			}
		}
	},
	methods: {
		openAccordion(panelName) {
			this.openPanels[panelName] = !this.openPanels[panelName];
		},
		exportInUse() {
			const link = document.createElement('a');
            link.href = '/api/exportitemsinuse?id=' + this.filterCompany + '&status=in_gebruik'
            document.body.appendChild(link);
            link.click();

		},
		exportInStock() {
			const link = document.createElement('a');
            link.href = '/api/exportitemsinuse?id=' + this.filterCompany + '&status=op_afroep'
            document.body.appendChild(link);
            link.click();

		},
		exportInRepair() {
			const link = document.createElement('a');
            link.href = '/api/exportitemsinuse?id=' + this.filterCompany + '&status=reparatie'
            document.body.appendChild(link);
            link.click();
		},
		loadData(){

			this.$xhr.get('/api/getstatistics/' + this.filterCompany + '/' + this.filterYear).then( ( {result}) => {
				this.total_items_in_stock = result['total_items_in_stock'];
				this.total_items_in_use = result['total_items_in_use'];
				this.total_items_in_repair = result['total_items_in_repair'];
				this.usedCategories = result['usedCategories'];
				this.inStockCategories = result['inStockCategories'];
				this.inRepairCategories = result['inRepairCategories'];
				this.loading = false;
				this.endOfLife = result['eolItems'];
				this.repairsPerMonth = result['repairItems'];
				this.repairsPerMonth = Object.entries(this.repairsPerMonth || {}).map(([month, amount]) => ({month, amount}));
				this.assetManagementChart.datasets = this.generateDatasets(result.itemInUse, 'bar', this.colors, null, false, true, true);

				// bulk
				this.bulk.datasets = this.generateDatasets(result.deliveries.totalbulkItems, 'bar', '#F9A98C', 2)
					.concat(this.generateDatasets(result.deliveries.daysBulkPerMonth, 'line', '#2570B0', 1));

				// indienst
				this.enlistments.datasets = this.generateDatasets(result.deliveries.enlistmentItems, 'bar', '#F9A98C', 2,  false, false)
					.concat(this.generateDatasets(result.deliveries.daysEmployedPerMonth, 'line', '#2570B0', 1));

				// uitdienst
				this.departures.datasets = this.generateDatasets(result.departures, 'bar', '#F9A98C', 2)
					.concat(this.generateDatasets(result.deliveries.daysDeparturePerMonth, 'line', '#2570B0', 1));

				// swap
				this.swapRequests.datasets = this.generateDatasets(result.swapItems, 'bar', '#F9A98C', 2)
					.concat(this.generateDatasets(result.deliveries.daysRepairPerMonth, 'line', '#1570B0', 1));

				this.mutationRequests.datasets = this.generateDatasets(result.deliveries.daysMutationsPerMonth, 'bar', '#F9A98C', 1);

			}).catch( (e) => {
				this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Statistieken kunnen niet worden ingeladen'});
			});
		},
		generateDatasets(data, type, color, order = null, firstOnly = false, excludeZero = false, useDifferentColors = false) {

			let datasets = Object.entries(data).map(([key, value], index) => {
				let c = useDifferentColors ? color[index % color.length] : color;
				return {
					label: key,
					data: value,
					backgroundColor: c,
					type: type,
					order: order,
					borderColor: c
				};
			});

			if (excludeZero) {
				datasets = datasets.filter(dataset => dataset.data.reduce((a, b) => a + b, 0) > 0);
			}

			return firstOnly ? datasets.filter(dataset => dataset.label.toLowerCase() === 'totaal') : datasets;
		},
	},
	computed: {
		yearOptions() {
			const startYear = 2022;
			const endYear = new Date().getFullYear() + 1;
			const years = Array.from({length: endYear - startYear + 1}, (_, i) => startYear + i);
			return years.map(year => ({value: year, name: year.toString(), id: year}));
		}
	},
	mounted(){
		this.$xhr.get('/api/getallendcustomers').then( ( {result}) => {
				this.customers = result;
			}).catch( (e) => {
				this.$store.dispatch('toast/alert', {title: 'Foutmelding', text: 'Klanten kunnen niet worden ingeladen'});
		});
	}

}
</script>
